import React from "react"

class Header extends React.Component {
  render() {
    return (
      <header>
        <h1 className="logo">
          <img src="https://sc-img-assets.s3.amazonaws.com/assets/logo.svg" alt="" />
        </h1>
        <div className="fb-like" 
          data-href="https://www.facebook.com/wiseGEEK/"
          data-width=""
          data-layout="button_count"
          data-action="like"
          data-size="small"
          data-share="false">
        </div>
      </header>
    )
  }
}

export default Header
